import React from "react";

export function ConditionalIcon(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="16" height="16" {...props} viewBox="0 0 16 16" fill="currentColor" stroke="none">
      <path d="M12.8 12.4a2.4 2.4 0 0 0-4.62-.93A1.6 1.6 0 0 1 7.2 10V6.8c0-.57-.16-1.12-.45-1.6h4.59a2.4 2.4 0 1 0 0-1.6H4.66a2.4 2.4 0 1 0-.04 1.73A1.6 1.6 0 0 1 5.6 6.8V10a3.2 3.2 0 0 0 2.53 3.12 2.4 2.4 0 0 0 4.67-.73Zm1.6-8a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Zm-12.8 0a.8.8 0 1 1 1.6 0 .8.8 0 0 1-1.6 0Zm8 8a.8.8 0 1 1 1.6 0 .8.8 0 0 1-1.6 0Z" />
    </svg>
  );
}
